import { FormContext, FormControl, FormGroup, FormLabel, OverlayTrigger } from '@hai/ui-react';
import { FormikProps } from 'formik';
import React, { MutableRefObject, useState } from 'react';
import { FormChangeEvent, FormChangeHandler } from 'src/js/util/global-type';
import { isNilOrEmpty } from 'src/js/util/global-util';

interface Props {
  id?: string;
  className?: string;
  mask?: boolean;
  inputClassName?: string;
  title?: string;
  name: string;
  value?: string;
  defaultValue?: string;
  disabled?: boolean;
  placeholder?: string;
  hint?: string;
  alwaysShowHint?: boolean;
  required?: boolean;
  type?: string;
  tooltip?: string | React.ReactNode;
  autoComplete?: string;
  pwdToggle?: boolean;
  onChange?: FormChangeHandler;
  onKeyUp?: (event: React.KeyboardEvent<HTMLInputElement> & FormChangeEvent) => void;
  autoFocus?: boolean;
  inputRef?: MutableRefObject<any>;
  maxLength?: number;
  style?: any;
  suffix?: string | React.ReactNode;
}

export const FormTextfield: React.FunctionComponent<Props> = ({
  id,
  className,
  mask,
  inputClassName,
  title,
  name,
  value,
  defaultValue,
  placeholder,
  hint,
  alwaysShowHint = false,
  required = false,
  type = 'text',
  tooltip,
  autoComplete = 'off',
  pwdToggle = false,
  disabled,
  onChange,
  onKeyUp,
  autoFocus,
  inputRef,
  maxLength,
  style,
  suffix,
}) => {
  const checkIfNumber = (event: React.KeyboardEvent<HTMLInputElement> & FormChangeEvent) => {
    return (
      !/(^\d*$)|(Backspace|Tab|Delete|ArrowLeft|ArrowRight|Control|Meta|Home|End|v|c|x)/.test(event.key) &&
      event.preventDefault()
    );
  };

  const [focus, setFocus] = useState(false);

  return (
    <FormContext.Consumer>
      {(formContext: FormikProps<any>) => {
        // If HAIUI ever handles this internally for checkbox we could remove this block of formik code
        const meta = formContext?.getFieldMeta(name);
        const invalid = !!meta.error;

        const showHint: boolean | 'always' = alwaysShowHint ? 'always' : !invalid && !isNilOrEmpty(hint) ? true : false;
        let placeholderForHaiui = focus ? hint ?? placeholder : placeholder ?? hint;
        if (placeholder && hint) {
          placeholderForHaiui = placeholder; // keep it simple if we provided both
        }
        
        /*
        if (name == 'ttl') {
          console.log('invalid', name, invalid, meta.error);
          console.log('meta.value', meta.value);
          console.log('showHint', showHint);
          console.log('hint', hint);
          console.log('placeholderForHaiui', placeholderForHaiui);
        }*/

        return (
          <FormGroup
            className={className}
            //style={style}
            {...{ style: style }}
          >
            <FormLabel required={required} htmlFor={id || name}>
              {title}
            </FormLabel>
            <FormControl
              id={id || name}
              name={name}
              useFsMask={mask}
              className={inputClassName}
              disabled={disabled}
              inputRef={inputRef}
              //  as={type === 'number' ? 'number-input' : undefined} to have the new design
              type={type}
              pwdToggle={pwdToggle}
              value={value}
              defaultValue={defaultValue}
              //   onKeyUp={onKeyUp}
              {...{ onKeyUp: onKeyUp }}
              onKeyDown={(event: React.KeyboardEvent<HTMLInputElement> & FormChangeEvent) =>
                type === 'number' && checkIfNumber(event)
              }
              onChange={onChange}
              onFocus={(): void => {
                setFocus(true);
              }}
              onBlur={(): void => {
                setFocus(false);
              }}
              autoFocus={autoFocus}
              autoComplete={autoComplete}
              placeholder={placeholderForHaiui}
              showHint={showHint}
              hintText={hint}
              maxLength={maxLength}
              prependAppend={suffix ? { append: suffix as string } : undefined}
            />
            {tooltip != null && <div className="mk-field-tooltip"><OverlayTrigger popoverContent={tooltip} placement="top"><div className="filler">{tooltip}</div></OverlayTrigger></div>}
          </FormGroup>
        );
      }}
    </FormContext.Consumer>
  );
};
